
import { ResponsivePieCanvas } from '@nivo/pie'

const TreatmentsBySkin = ({ data }) => {
    return (<div className='reportChart' style={ { width: '100%', height: 300, maxHeight: 340 } }>
        <h4>Treatments by Skin Type</h4>
        {data.length > 0 ? <ResponsivePieCanvas
                data={ data.map((d) => {
                    return {
                        id: "Type " + d.skin_type,
                        label: "Skin Type " + d.skin_type,
                        value: d.count
                    }
                }) }
                margin={ { top: 40, right: 0, bottom: 40, left: 0 } }
                innerRadius={ 0.6 }
                padAngle={ 0.7 }
                activeOuterRadiusOffset={ 8 }
                colors={[
                    '#93d5ed',
                    '#5c9ceb',
                    '#2e7de4',
                    '#1d5ba6',
                ]}
                borderColor="#000000"
                enableArcLinkLabels={ true }
                arcLinkLabelsSkipAngle={ 10 }
                arcLinkLabelsTextColor="#333333"
                arcLinkLabelsThickness={ 2 }
                arcLinkLabelsColor={ { from: 'color' } }
                arcLabelsSkipAngle={ 10 }
                arcLabelsTextColor="#333333"
            /> : <div className='noData'>No data available</div>}
    </div>)
}


export default TreatmentsBySkin;